export interface IAssociationLogo {
  url: string;
  name: string;
  show: number;
  image_url?: string;
  image_preview: string;
  image?: File;
}
export type AssociationLogoPreview = Pick<IAssociationLogo, 'image_preview' | 'image' | 'name' | 'url'>;
